import { render, staticRenderFns } from "./xzqhDialog.vue?vue&type=template&id=0908444c&scoped=true&"
import script from "./xzqhDialog.vue?vue&type=script&lang=js&"
export * from "./xzqhDialog.vue?vue&type=script&lang=js&"
import style0 from "./xzqhDialog.vue?vue&type=style&index=0&id=0908444c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0908444c",
  null
  
)

export default component.exports